export default __webpack_public_path__ + "static/media/group2.2287376c.png";